class Controller {
  constructor(
    $injector,
    $stateParams,
    GoogleMaps,
    CorporateTransportationSubmissionTransforms
  ) {
    "ngInject";
    this.$injector = $injector;
    this.$stateParams = $stateParams;
    this.corporateTransportationSubmissions = $injector.get(
      "CorporateTransportationSubmissions"
    );
    this.googleMapsUrl = GoogleMaps.getSource();
    this.CorporateTransportationSubmissionTransforms = CorporateTransportationSubmissionTransforms;
  }

  $onInit() {
    this.corporateTransportationSubmissions
      .get(this.$stateParams.id)
      .$promise.then((response) => {
        this.corporateTransportationSubmission = this.CorporateTransportationSubmissionTransforms.justify(
          response
        );
        this.corporateLocation = [
          Number(this.corporateTransportationSubmission.location.lat),
          Number(this.corporateTransportationSubmission.location.lng),
        ];
      });

    this.onMapInit = (map) => {
      map.setZoom(14);
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporateTransportationSubmission/corporateTransportationSubmission.controller.js